export const getStickyClass = (index) => {
    if (index === 0) return 'sticky-col sticky-1';
    if (index === 1) return 'sticky-col sticky-2';
    return '';
};

export const downloadCsv = (filename, headers, rows) => {
    if (!headers.length || !rows.length) return;
    const escape = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`;
    const lines = [
        headers.map(escape).join(','),
        ...rows.map((row) => row.map(escape).join(','))
    ].join('\n');
    const blob = new Blob([`﻿${lines}`], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};
